import {MouseEvent, useState} from "react";
import createClient from "openapi-fetch";
import {paths} from "../listan-backend-api";

const client = createClient<paths>();

export default function NewList(
    {
        className
    } : {
        className?: string | null
    }) {

    const [disabled, setDisabled] = useState(false);

    const newListClick = (event: MouseEvent<HTMLButtonElement> ) => {
        // Stop double click
        setDisabled(true);

        client.POST("/api/list")
            .then((result) => {
                if (result.response.ok && result.data) {
                    // Todo rewrite as a url rewrite. This requires some more code to handle url state a bit better
                    window.location.href = "index.html?listid=" + result.data.listId;
                }
            })
            .catch(console.error)
            .finally(() => {
                setDisabled(false);
            });
    };

    return (
        <>
            <button className={"new-list " + (className ?? "")} disabled={disabled} onClick={newListClick}>Ny lista</button>
        </>
    );
}
